export const getUserAgent = function() {
    return window.navigator.userAgent;      
}

export const getUserScreenSize = function() {
    return {w: window.screen.width, h: window.screen.height};
}

export const getImageDimensions = function(imgSrc, callback) {
    let img = document.createElement("img");
    img.src = imgSrc;

    let wait = setInterval(function() {
        let w = img.naturalWidth,
            h = img.naturalHeight;
        if (w && h) {
          clearInterval(wait);
          callback.apply(this, [w, h]);
         
        }
    }, 10);
}

// As per the video by Dev Ed youtube.com/watch?v=oUSvlrDTLi4 with added offset support
export const smoothScroll = function(target, duration, offset) {
    let targetElem = document.querySelector(target);
    let targetPosition = offset ? targetElem.getBoundingClientRect().top - offset : targetElem.getBoundingClientRect().top;
    let startPosition = window.pageYOffset;
    let distance = targetPosition - startPosition;
    let startTime = null;
    
    function animation (currentTime) {
        if (startTime === null) startTime = currentTime;  
        let timeElapsed = currentTime - startTime;
        let run = easeOutExpo (timeElapsed, startPosition, distance, duration);
        window.scrollTo(0, run);
        if(timeElapsed < duration) requestAnimationFrame(animation)
    }

    function easeOutExpo (t, b, c, d) {
        return c * ( -Math.pow( 2, -10 * t/d ) + 1 ) + b;
    }
    
    requestAnimationFrame(animation);
    // After scrolling remove hash to avoid not being able to scroll to hash since "we are already there"
    location.hash = "";
}